export default {
  title: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_-title',
    defaultMessage: 'Listings in trouble',
  },
  subtitle: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_-subtitle',
    defaultMessage:
      'We get it — your goods are quality. But you need to drop these prices a lot to win BackBoxes.',
  },
  info: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_-info',
    defaultMessage:
      'Win {count} BackBoxes by decreasing your prices by an average of {percentage}%',
  },
  success: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_-success',
    defaultMessage: 'Nice work. Your items are priced to sell.',
  },
  fetchingData: {
    id: 'bo_sellers-opportunities-pricing-fetching_data',
    defaultMessage: 'Fetching opportunities',
  },
  saveTime: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_save_time',
    defaultMessage: 'And save time by winning all of these BackBoxes at once.',
  },
  items: {
    id: 'bo_sellers-opportunities-pricing-listings_in_trouble_items',
    defaultMessage: `{count, plural,
      =0 {0 item}
      one {# item}
      other {# items}
    }`,
  },
}
